import React from "react";
import "./ProcessingFees.css";

export default function ProcessingFees() {
  return (
    <section className="ijacna-processing-section">
      <div className="ijacna-processing-container">
        <h2 className="ijacna-processing-title">Processing Fees</h2>
        <p className="ijacna-processing-description">
          IJACNA is an open access journal where all the operating expenses are
          met from the article processing charges. The article processing
          charges of the accepted articles are as follows:
        </p>

        <div className="ijacna-processing-fees">
          <p>
            <strong>Indian Authors :</strong> INR 15000/-
          </p>
          <p>
            <strong>International Authors :</strong> USD 250
          </p>
        </div>
      </div>
    </section>
  );
}
